import { useMemo } from "react";
import { useGlobalSettings } from "../context/GlobalSettingsContext";

export const useCurrencyFormatter = () => {
  const { settings } = useGlobalSettings();

  return useMemo(
    () =>
      (amount: string | number, stripZeros: boolean = false): string => {
        const value = typeof amount === "string" ? parseFloat(amount) : amount;
        if (isNaN(value)) return "";

        const num = new Intl.NumberFormat(undefined, {
          style: "currency",
          currency: settings.currency,
        }).format(value);

        if (stripZeros && num.endsWith(".00")) {
          return num.slice(0, -3);
        }
        return num;
      },
    [settings.currency],
  );
};
